const LINK_WINDOW_LOADER_HTML = `<!doctype html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Loading</title>
  <style>
    html, body {
      margin: 0;
      width: 100%;
      height: 100%;
      background: #000;
    }

    body {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

    .spinner {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      border: 4px solid rgba(0, 255, 127, 0.2);
      border-top-color: #00ff7f;
      animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  </style>
</head>
<body>
  <div class="spinner"></div>
</body>
</html>`

const isTelegramWebAppAvailable = () => {
  return Boolean(window.Telegram?.WebApp?.initData)
}

const isTelegramUrl = (url) => {
  try {
    const normalizedUrl = new URL(url)
    return ['t.me', 'www.t.me', 'telegram.me', 'www.telegram.me'].includes(normalizedUrl.hostname)
  } catch {
    return false
  }
}

export const prepareBrowserLinkWindow = () => {
  if (isTelegramWebAppAvailable()) {
    return null
  }

  const preparedWindow = window.open('', '_blank')

  if (!preparedWindow) {
    return null
  }

  try {
    preparedWindow.opener = null
    preparedWindow.document.write(LINK_WINDOW_LOADER_HTML)
    preparedWindow.document.close()
  } catch (error) {
    console.warn('⚠️ Не удалось подготовить окно ссылки:', error)
  }

  return preparedWindow
}

export const closePreparedBrowserLinkWindow = (preparedWindow) => {
  if (!preparedWindow || preparedWindow.closed) {
    return
  }

  try {
    preparedWindow.close()
  } catch (error) {
    console.warn('⚠️ Не удалось закрыть подготовленное окно ссылки:', error)
  }
}

export const openTelegramOrBrowserLink = (url, options = {}) => {
  const { preparedWindow = null } = options

  if (!url) {
    return false
  }

  if (isTelegramWebAppAvailable()) {
    try {
      if (isTelegramUrl(url) && window.Telegram?.WebApp?.openTelegramLink) {
        window.Telegram.WebApp.openTelegramLink(url)
        return true
      }

      if (window.Telegram?.WebApp?.openLink) {
        window.Telegram.WebApp.openLink(url)
        return true
      }
    } catch (error) {
      console.error('❌ Не удалось открыть ссылку через Telegram WebApp:', error)
    }
  }

  if (preparedWindow && !preparedWindow.closed) {
    preparedWindow.location.replace(url)
    return true
  }

  const openedWindow = window.open(url, '_blank')

  if (openedWindow) {
    try {
      openedWindow.opener = null
    } catch (error) {
      console.warn('⚠️ Не удалось очистить opener у окна ссылки:', error)
    }

    return true
  }

  window.location.assign(url)
  return true
}

export default openTelegramOrBrowserLink
